import { Chip, ChipProps } from '@mui/material';
import { FC } from 'react';

export const BetaChip: FC<ChipProps> = props => <Chip label={'beta'} color="info" {...props} />;
